export enum MetaModelField {
  Fields = 'fields',
  IdField = 'id',
  TypeField = 'type',
  Collection = 'collection',
  OriginalId = 'originalId',
  Patch = 'patch',
  PatchListeners = 'patchListeners',
  Commit = 'commit',
}
